<template>
  <div class='treeview'>
    <ul class="pl-1 pt-1">
      <li>
        <div v-if="showRoot" class="treeview-item">
          <div>
            <i class="fas fa-hdd text-third treeview-item-icon"></i>
            <strong>{{ rootName }}</strong>
          </div>
          <div class="form-inline" v-show="!isSearching && hasRole(roles.RW_OPER_DOC_ROOT_FOLDERS)">
            <i class="fa fa-plus-circle text-third pl5" style="cursor:pointer" v-show="showAddButton && !isUndeleting" @click="onAdd(null, $event)"></i>
          </div>
        </div>
      </li>
      <draggable
        class="draggable-element"
        :list="list"
        :move="onMove"
        :disabled="!canDrag"
        group="pastas"
        @change="onChange"
        @start="startMove"
        @end="onEndMove"
        itemKey="nome">
        <file-tree-view-item v-for="it in list"
          ref="treeviewItem"
          :item="it"
          :key="it.id"
          :startOpen="startOpen"
          :showEditButton="showEditButton"
          :showAddButton="showAddButton"
          :showChangeStatusButton="showChangeStatusButton"
          :showDeleteButton="showDeleteButton"
          :showDownloadButton="showDownloadButton"
          :showCheckbox="showCheckbox"
          :showBackButton="showBackButton"
          :showUndeleteButton="showUndeleteButton"
          :showCopyStructureButton="showCopyStructureButton"
          :isModal="isModal"
          :isUndeleting="isUndeleting"
          :isSearching="isSearching"
          :serializer="serializer"
          :childrenField="childrenField"
          :iconBeforeName="iconBeforeName"
          :isStructCopySet="isStructCopySet"
          :isDragging="isDragging"
          :canDrag="canDrag"
          :elementTargetId = "elementTargetId"
          v-on:open="onOpen"
          v-on:close="onClose"
          v-on:selectitem="onSelectItem"
          v-on:edit="onEdit"
          v-on:add="onAdd"
          v-on:changestatus="onChangeStatus"
          v-on:delete="onDelete"
          v-on:undelete="onUndelete"
          v-on:back="onBack"
          v-on:structCopy="onStructCopy"
          v-on:structCopyExecute="onStructCopyExecute"
          v-on:move="onMove"
          v-on:endMove="onEndMove"
          v-on:change="onChange" >
          <slot :item="it"></slot>
          <template #afterName="slotProps">
            <slot name="afterName" :item="slotProps.item"></slot>
          </template>
        </file-tree-view-item>
      </draggable>
    </ul>
  </div>
</template>

<script>
import FileTreeViewItem from './FileTreeViewItem.vue'
import Roles from '@/shared/utils/roles.js'
import PermissionMixin from '@/store/module/permission/mixin'
import draggable from 'vuedraggable'
import GedFolderRepository from '@/shared/http/repositories/business/gedfolder'
import { loading } from '@/shared/utils/UIHelper'

export default {
  name: 'FileTreeView',
  model: {
    prop: 'list'
  },
  mixins: [ PermissionMixin ],
  data () {
    return {
      roles: Roles,
      isDragging: false,
      elementTargetId: null,
      parentFolderId: null
    }
  },
  props: [
    'list',
    'rootName',
    'startOpen',
    'showEditButton',
    'showAddButton',
    'showChangeStatusButton',
    'showDeleteButton',
    'showDownloadButton',
    'showCheckbox',
    'showBackButton',
    'showUndeleteButton',
    'showCopyStructureButton',
    'showRoot',
    'canDrag',
    'isModal',
    'serializer',
    'childrenField',
    'fatherId',
    'idField',
    'isUndeleting',
    'isSearching',
    'iconBeforeName',
    'endMove',
    'isStructCopySet'
  ],
  components: {
    FileTreeViewItem,
    draggable
  },
  methods: {
    startMove () {
      this.isDragging = true
    },
    onMove (evt) {
      this.elementTargetId = evt.dragged.id
    },
    onEndMove (evt) {
      const h = this.$createElement
      let messageVNode = h('div', [
        h('h4', [
          this.$lang.Common.LabelConfirmation
        ]),
        h('br')
      ])

      this.$bvModal.msgBoxConfirm([messageVNode], {
        title: this.$lang.Documents.Menu.ConfirmationMove,
        centered: true,
        okTitle: this.$lang.Common.Yes,
        cancelTitle: this.$lang.Common.No,
        headerClass: 'justify-content-center'
      })
        .then(value => {
          if (value) {
            loading.push()
            GedFolderRepository.PatchParentFolder(this.elementTargetId, { pastaPaiId: this.parentFolderId })
              .then(response => {})
              .catch(err => console.log(err))
              .finally(() => {
                this.$emit('endMove', this.elementTargetId, { pastaPaiId: this.parentFolderId })
                this.parentFolderId = null
                this.elementTargetId = null
                this.isDragging = false
                loading.close()
              })
          } else {
            this.parentFolderId = null
            this.elementTargetId = null
            this.isDragging = false
            this.$emit('endMove', evt)
          }
        })
    },
    onChange (log) {
      if (log.added) {
        if (log.added.newIndex === 0) {
          let parentFolder = document.getElementById(this.elementTargetId).parentElement
          while (parentFolder && parentFolder.tagName !== 'LI') {
            parentFolder = parentFolder.parentElement
          }

          this.parentFolderId = parentFolder ? parentFolder.id : null
          return
        }
        this.parentFolderId = document.getElementById(this.elementTargetId).previousSibling.id
      }
      if (log.moved) {
        if (log.moved.newIndex === 0) {
          return
        }
        this.parentFolderId = document.getElementById(this.elementTargetId).previousSibling.id
      }
    },
    closeAll () {
      if (this.$refs.treeviewItem) {
        this.$refs.treeviewItem.forEach(i => {
          i.closeAll()
        })
      }
    },
    onAdd (item, event) {
      this.setChecked(item)
      this.$emit('add', item)
    },
    onEdit (item, event) {
      this.setChecked(item)
      this.$emit('edit', item)
    },
    onOpen (folder) {
      this.$emit('open', folder)
    },
    onClose () {
      this.$emit('close')
    },
    onSelectItem (item) {
      this.setChecked(item)
      this.$emit('selectitem', item)
    },
    onChangeStatus (item) {
      this.$emit('changestatus', item)
    },
    onDelete (item) {
      this.$emit('delete', item)
    },
    onUndelete (item) {
      this.$emit('undelete', item)
    },
    onBack (item) {
      this.$emit('back', item)
    },
    onStructCopy (item) {
      this.$emit('structCopy', item)
    },
    onStructCopyExecute (item) {
      this.$emit('structCopyExecute', item)
    },
    setChecked (item) {
      const _setChecked = (item1, item2) => {
        const id = this.idField || 'id'
        if (item1) {
          this.$set(item1, 'checked', item2 && item1[id] === item2[id])

          if (item1[this.childrenField]) {
            item1[this.childrenField].forEach(ch => {
              _setChecked(ch, item2)
            })
          }
        }
      }

      this.list.forEach(itms => { _setChecked(itms, item) })
    },
    getOpenedIds () {
      const openedIds = []
      if (this.$refs.treeviewItem) {
        this.$refs.treeviewItem.forEach(i => {
          if (i.open) {
            openedIds.push(i.item.id)
            i.getOpenedIds(openedIds)
          }
        })
        return openedIds
      }
    }
  }
}
</script>

<style scoped>
.treeview {
  padding: 0px;
  background-color: #fff;
  width: 100%;
}

.treeview >>> ul li {
  list-style-type: none;
  width: 100%;
}

span.treeview >>> treeview-item i,
a {
  font-size: 12px;
}

.treeview >>> .treeview-item {
  padding-top: 6px;
  padding-bottom: 2px;
  padding-right: 5px;
  padding-left: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.treeview >>> .treeview-item::not(.treeview-item-selected) {
  border-bottom: solid 1px #f5f5f5;
}

.treeview >>> .treeview-item-unselected,
.treeview >>> .treeview-item-selected {
  cursor: cell;
}

.treeview >>> .treeview-item-icon {
  padding-right: 6px;
}

* >>> .pl0 {
  padding-left: 0px;
}
* >>> .pr5 {
  padding-right: 5px;
}
* >>> .pl5 {
  padding-left: 5px;
}
* >>> .pl10 {
  padding-left: 10px;
}
* >>> .pl15 {
  padding-left: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/documents/components/treeview/FileTreeView.vue